<template>
    <div class="columns full-width is-multiline">
        <div class="column is-12 is-9-hd is-9-hd-wide is-9-hd-plus">
            <div class="columns toolbar-box">
                <div class="column is-3">
                    <h1 class="title is-3 between-center">
                        <span>
                            <span>Proposal Conversion Rates</span>
                            <a href="#" @click.prevent="isTableSettingsModalActive = true" class="gear">
                                <o-icon pack="fa" icon="gear" size="is-small" />
                            </a>
                        </span>
                    </h1>
                </div>
                <div class="column is-3">
                    <o-field>
                        <autocomplete-select type="user" placeholder="User" field-name="full_name"
                            v-model="filters.user_id" :value="userById(parseInt(filters.user_id))"
                            @update:modelValue="fetchPaginatedData()" />
                    </o-field>
                </div>
                <div class="column is-2">
                    <o-field>
                        <o-select :expanded="true" placeholder="Year" v-model="filters.year"
                            @update:modelValue="fetchPaginatedData(true)">
                            <option value="">Select Year</option>
                            <option :key="year" :value="year" v-for="year in years">
                                {{ year }}
                            </option>
                        </o-select>
                    </o-field>
                </div>
                <div class="column is-2">
                    <o-field>
                        <o-select :expanded="true" placeholder="Month" v-model="filters.month"
                            @update:modelValue="fetchPaginatedData(true)">
                            <option value="">Select Month</option>
                            <option :key="month.id" :value="month.id" v-for="month in months">
                                {{ month.name }}
                            </option>
                        </o-select>
                    </o-field>
                </div>
            </div>

            <o-table class="is-responsive is-dashboard-proposal " :data="paginatedData" v-if="isTableVisible"
                :bordered="table.bordered" :striped="table.striped" :narrowed="table.narrowed"
                :checkable="table.checkable" :mobile-cards="table.mobileCards" :per-page="table.perPage"
                :default-sort="table.defaultSort" :key="paginatedData" :root-class="table.rootClass"
                :checked-rows="checkedRows" @update:checkedRows="$event => checkedRows = $event" :loading="loading"
                :total="total" backend-sorting backend-pagination @page-change="onPageChange" @sort="onSort">
                <template>
                    <o-table-column #default="{ row }">
                        #
                    </o-table-column>
                    <o-table-column v-for="col in tableColumns" v-bind="col" #default="{ row }">
                        <span v-if="col.field === 'date'">
                            <span v-if="filters.month === 'yearly'">{{ row.date }}</span>
                            <span v-else>
                                {{ $filters.date(row.date) }}
                            </span>
                        </span>

                        <span v-else-if="col.field === 'proposals_count'">
                            <a href="#" @click.prevent="openProposalsModalTable(row.date)">
                                {{ row[col.field] }}
                            </a>
                        </span>
                        <span v-else-if="col.field === 'converted_count'">
                            <a href="#" @click.prevent="openProposalsModalTable(row.date, 'converted')">
                                {{ row[col.field] }}
                            </a>
                        </span>
                        <span v-else-if="col.field === 'change_order_value'">
                            <a href="#" @click.prevent="openChangeOrderModalTable(row.date, 'changeOrder')">
                                {{ $filters.currency(row[col.field]) }}
                            </a>
                        </span>
                        <span v-else-if="col.field === 'conversion_rate'">
                            {{ $filters.toFixed(row[col.field]) }}
                        </span>
                        <span v-else-if="col.field === 'rolling_proposals_avg_6mo'">
                            %{{ $filters.toFixed(row[col.field]) }}
                        </span>
                        <span v-else-if="col.field === 'rolling_conversion_rate_6mo'">
                            %{{ $filters.toFixed(row[col.field]) }}
                        </span>
                        <span v-else-if="col.field === 'proposals_total_value'">
                            {{ $filters.currency(row[col.field]) }}
                        </span>
                        <span v-else-if="col.field === 'converted_value'">
                            {{ $filters.currency(row[col.field]) }}
                        </span>
                        <span v-else-if="col.field === 'converted_value_avg'">
                            %{{ $filters.toFixed(row[col.field]) > 100 ? 100 : $filters.toFixed(row[col.field]) }}
                        </span>
                        <span v-else-if="col.field === 'total_value'">
                            {{ $filters.currency(row[col.field]) }}
                        </span>
                        <span v-else-if="col.field === 'fte'">
                            {{ row[col.field] }}
                        </span>
                    </o-table-column>
                </template>
                <template #footer>
                    <th>Total</th>
                    <th v-for="col in tableColumns" :key="col.field">
                        <span v-if="col.field === 'proposals_count'">{{ summary.proposalsCount }}</span>
                        <span v-else-if="col.field === 'converted_count'">{{ summary.convertedCount }}</span>
                        <span v-else-if="col.field === 'conversion_rate'">{{ summary.conversionRate }}</span>
                        <span v-else-if="col.field === 'proposals_total_value'">{{
                            $filters.currency(summary.proposalsTotalValue) }}</span>
                        <span v-else-if="col.field === 'converted_value'">{{ $filters.currency(summary.convertedValue)
                            }}</span>
                        <!-- <span v-else-if="col.field === 'converted_value_avg'">%{{
                            $filters.toFixed(summary.convertedValueAverage, 2) }}</span> -->
                        <span v-else-if="col.field === 'change_order_value'">{{ $filters.currency(summary.changeOrders)
                            }}</span>
                        <span v-else-if="col.field === 'total_value'">{{ $filters.currency(summary.totalValue) }}</span>
                        <span v-else>-</span>
                    </th>
                </template>
                <template v-slot:empty>
                    <div class="has-text-centered">
                        This table is empty!
                    </div>
                </template>
            </o-table>
            <br>
            <div class="columns is-hidden-tablet" v-if="isTableVisible">
                <div class="column is-offset-8 is-4">
                    <b-panel :collapsible="true">
                        <strong>Year Summary</strong>
                        <div class="content full-width">
                            <p class="between-center"><strong>Proposals Count:</strong>
                                <span>{{ summary.proposalsCount }}</span>
                            </p>
                            <p class="between-center"><strong>Converted Count:</strong>
                                <span>{{ summary.convertedCount }}</span>
                            </p>
                            <p class="between-center"><strong>Conversion Rate:</strong>
                                <span>{{ summary.conversionRate }}%</span>
                            </p>
                            <p class="between-center"><strong>Proposals Total Value</strong>
                                <span>{{ $filters.currency(summary.proposalsTotalValue) }}</span>
                            </p>
                            <p class="between-center"><strong>Converted Value:</strong>
                                <span>{{ $filters.currency(summary.convertedValue) }}</span>
                            </p>
                            <p class="between-center"><strong>Converted Value Average:</strong>
                                <span>{{ $filters.currency(summary.convertedValueAverage) }}</span>
                            </p>
                            <p class="between-center"><strong>Change Orders:</strong>
                                <span>{{ $filters.currency(summary.changeOrders) }}</span>
                            </p>
                            <p class="between-center"><strong>Total:</strong>
                                <span>{{ $filters.currency(summary.totalValue) }}</span>
                            </p>
                        </div>
                    </b-panel>
                </div>
            </div>
            <hr>
            <yearly-comparison />
        </div>
        <div class="column is-12 is-3-hd is-3-hd-wide is-3-hd-plus">
            <h1 class="title is-3 between-center">
                <span>Proposal Sources</span>
            </h1>
            <div class="chart-wrapper lead-sources-chart" v-if="leadSourcesStats">
                <o-field>
                    <o-select :expanded="true" placeholder="Year" v-model="leadSourcesYear"
                        @update:modelValue="leadSourcesYear = $event">
                        <option value="">Select Year</option>
                        <option :key="year" :value="year" v-for="year in years">
                            {{ year }}
                        </option>
                    </o-select>
                </o-field>
                <Pie :data="leadSourcesStats" ref="LeadsPie" datasetIdKey="labels" :options="optionsClick2" />
            </div>

            <h1 class="title is-3 between-center">
                <span>Proposal Statuses</span>
            </h1>
            <div class="chart-wrapper proposal-statuses-chart" v-if="proposalStatusesStats.length !== 0">
                <o-field>
                    <o-select :expanded="true" placeholder="Year" v-model="statusesYear"
                        @update:modelValue="statusesYear = $event">
                        <option value="">Select Year</option>
                        <option :key="year" :value="year" v-for="year in years">
                            {{ year }}
                        </option>
                    </o-select>
                </o-field>
                <Pie v-if="proposalStatusesStats" ref="ProposalsPie" :data="proposalStatusesStats" datasetIdKey="labels"
                    :options="optionsClick" />
            </div>
        </div>

        <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isProposalsModalActive"
            has-modal-card>
            <proposals-modal :status="currentStatus" :lead-source="currentLeadSource" :year="currentYear"
                :month="currentMonth" />
        </o-modal>

        <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isChangeOrderModalActive"
            has-modal-card>
            <change-orders-modal :year="currentYear" :month="currentMonth" />
        </o-modal>

        <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isTableSettingsModalActive"
            has-modal-card class="table-settings-modal">
            <table-settings-modal :slug="tableName" />
        </o-modal>
    </div>
</template>

<script>
import {
    ArcElement,
    BarElement,
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LinearScale,
    Title,
    Tooltip
} from 'chart.js'
import moment from "moment/moment"
import { Pie } from 'vue-chartjs'
import { mapActions, mapGetters } from 'vuex'
import ChangeOrdersModal from '../../../components/modals/ChangeOrders'
import ProposalsModal from '../../../components/modals/Proposals'
import Table from '../../../mixins/Table'
import YearlyComparison from './proposal-dashboard/YearlyComparison'

ChartJS.register(ArcElement, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
    mixins: [Table],

    components: { ProposalsModal, ChangeOrdersModal, YearlyComparison, Pie },

    data() {
        let currentYear = parseInt(moment().format('Y'))

        return {
            isProposalsModalActive: false,
            isChangeOrderModalActive: false,
            leadSourcesYear: currentYear,
            statusesYear: currentYear,
            tableName: 'proposal-conversion-rates',
            currentYear: currentYear,
            currentStatus: null,
            currentMonth: null,
            currentLeadSource: null,
            isTableSettingsModalActive: false,
            optionsClick: {
                responsive: true,
                onClick: (e) => {
                    const chart = this.$refs.ProposalsPie.chart;
                    const el = chart.getElementsAtEventForMode(
                        e,
                        'nearest',
                        { intersect: true },
                        false
                    )[0].index;
                    this.openProposalsModal(el, 'proposal-status')
                },
            },
            optionsClick2: {
                responsive: true,
                onClick: (e) => {
                    const chart = this.$refs.LeadsPie.chart;
                    const el = chart.getElementsAtEventForMode(
                        e,
                        'nearest',
                        { intersect: true },
                        false
                    )[0].index;
                    this.openProposalsModal(el, 'lead-source')
                },
            },

            proposalStatusesStats: {
                labels: [],
                datasets: [{
                    backgroundColor: [
                        '#38D5E4',
                        '#43EBC2',
                        '#96F891',
                        '#EDFC6A',
                        '#75B255',
                        '#3B971D',
                        '#E8769C',
                        '#C108B2',
                        '#A8C0F8',
                        '#A53531',
                        '#89E803',
                        '#B0BC33',
                        '#F3ED3C',
                        '#044A55'], data: []
                }]
            },
            leadSourcesStats: {
                labels: [],
                datasets: [{
                    backgroundColor: [
                        '#EDFC6A',
                        '#38D5E4',
                        '#43EBC2',
                        '#96F891',
                        '#75B255',
                        '#3B971D',
                        '#E8769C',
                        '#C108B2',
                        '#A8C0F8',
                        '#A53531',
                        '#81B8E9',
                        '#89E803',
                        '#B0BC33',
                        '#F3ED3C',
                        '#044A55'], data: []
                }]
            },

            months: [
                { "id": "yearly", "name": "Yearly" },
                { "id": 1, "name": "January" },
                { "id": 2, "name": "February" },
                { "id": 3, "name": "March" },
                { "id": 4, "name": "April" },
                { "id": 5, "name": "May" },
                { "id": 6, "name": "June" },
                { "id": 7, "name": "July" },
                { "id": 8, "name": "August" },
                { "id": 9, "name": "September" },
                { "id": 10, "name": "October" },
                { "id": 11, "name": "November" },
                { "id": 12, "name": "December" },
            ],

            table: {
                perPage: 12,
                defaultSort: ['date', 'desc'],
                rootClass: 'overflow',
            },

            filters: {
                user_id: '',
                year: currentYear,
                month: ''
            },
            summary: {
                proposalsCount: 0,
                convertedCount: 0,
                conversionRate: 0,
                proposalsTotalValue: 0,
                convertedValue: 0,
                convertedValueAverage: 0
            }
        }
    },

    mounted() {
        this.fetchPaginatedData()
        this.fetchProposalsLeadSources({ year: this.filters.year })
        this.fetchProposalStatusesSummary({ year: this.filters.year })

        $('.checkbox-cell').click((e) => {
            e.stopPropagation()
        })

        this.fetchProposalsLeadSources({ year: this.filters.year }).then((value) => {
            this.leadSourcesStats = {
                labels: value.map((leadSource) => leadSource.name),
                datasets: [{
                    data: value.map((leadSource) => leadSource.count)
                }]
            }
        })

        this.fetchProposalStatusesSummary({ year: this.filters.year }).then((value) => {
            this.proposalStatusesStats = {
                labels: value.map((status) => this.statusNameById(status.id)),
                datasets: [{
                    data: value.map((status) => status.count)
                }]
            }
        })
    },
    watch: {
        paginatedData(value) {
            if (value) {
                // _.forEach(value, v => v.total_value = v.total_value / 1000)
                this.summary.proposalsCount = this.getSum(value, p => p.proposals_count)
                this.summary.convertedCount = this.getSum(value, p => p.converted_count)
                this.summary.conversionRate = (this.summary.convertedCount / this.summary.proposalsCount * 100).toFixed(2)
                this.summary.proposalsTotalValue = this.getSum(value, p => p.proposals_total_value)
                this.summary.convertedValue = this.getSum(value, p => p.converted_value)
                // this.summary.convertedValueAverage = (this.summary.convertedValue / this.summary.convertedCount) / 1000
                this.summary.changeOrders = this.getSum(value, p => p.change_order_value)
                this.summary.totalValue = this.getSum(value, p => p.total_value)

                
            }

        },

        'leadSourcesYear'(value) {
            this.fetchProposalsLeadSources({ year: value }).then((value) => {
                this.leadSourcesStats = {
                    labels: value.map((leadSource) => leadSource.name),
                    datasets: [{
                        data: value.map((leadSource) => leadSource.count)
                    }]
                }
            })
        },
        'statusesYear'(value) {
            this.fetchProposalStatusesSummary({ year: value }).then((value) => {
                this.proposalStatusesStats = {
                    labels: value.map((status) => this.statusNameById(status.id)),
                    datasets: [{
                        data: value.map((status) => status.count)
                    }]
                }
            })
        }
    },

    methods: {
        ...mapActions({
            fetchData: 'fetchProposalStats',
            fetchProposalsLeadSources: 'fetchProposalsLeadSources',
            fetchProposalStatusesSummary: 'fetchProposalStatusesSummary',
            fetchProposalsData: "fetchProposalsData"
        }),

        openProposalsModal(segmentId, filterType) {
            this.currentMonth = null
            if (filterType === 'proposal-status') {
                this.currentLeadSource = null
                this.currentYear = this.statusesYear
                this.currentStatus = this.proposalStatusesSummary[segmentId].id
            } else if (filterType === 'lead-source') {
                this.currentStatus = null
                this.currentYear = this.leadSourcesYear
                this.currentLeadSource = this.proposalsLeadSources[segmentId].lead_source_id
            }

            this.isProposalsModalActive = true
        },

        openProposalsModalTable(date, status = null) {
            let parts = ('' + date).split('-')
            this.currentYear = parts[0]
            this.currentMonth = parts[1] === undefined ? null : parseInt(parts[1])
            this.currentStatus = status
            this.isProposalsModalActive = true
        },
        openChangeOrderModalTable(date) {
            let parts = ('' + date).split('-')
            this.currentYear = parts[0]
            this.currentMonth = parts[1] === undefined ? null : parseInt(parts[1])
            this.isChangeOrderModalActive = true
        },
        getSum(list, fn) {
            return list.map(fn).reduce((accumulator, currentValue) => accumulator + parseFloat(currentValue), 0)
        }
    },

    computed: {
        ...mapGetters({
            itemsByIds: 'proposalStatsByIds',
            statusNameById: 'statusNameById',
            proposalsLeadSources: 'proposalsLeadSources',
            proposalStatusesSummary: 'proposalStatusesSummary'
        }),

        ...mapGetters(['years', 'users', 'proposalStats', 'userNameById', 'userById']),

        // leadSourcesStats () {
        //     return [
        //       {
        //         labels: this.proposalsLeadSources.map((leadSource) => leadSource.name),
        //         values: this.proposalsLeadSources.map((leadSource) => leadSource.count)
        //       }
        //     ]
        // },
        //
        // proposalStatusesStats () {
        //     return [{
        //         names: this.proposalStatusesSummary.map((status) => this.statusNameById(status.id)),
        //         values: this.proposalStatusesSummary.map((status) => status.count)
        //     }]
        // }
    },
}
</script>

<style>
.overflow {
    overflow: auto !important;
}

@media screen and (max-width: 768px) {
    .is-dashboard-proposal tfoot {
        display: none;
    }
}
</style>